//initial values
const LoginInitialValues = {
  email: "",
  password: "",
};

const forgotPasswordInitialValues = {
  email: "",
};

const resetPasswordInitialValues = {
  password: "",
  confirmPassword: "",
};
const changePasswordInitialValues = {
  oldPassword: "",
  password: "",
  confirmPassword: "",
};
const profileInitialValues = {
  profileImage: "",
  firstName: "",
  lastName: "",
  emailAddress: "",
  countryCode: "",
  phoneNumber: "",
  location: "",
};

const growerInitialValues = {
  email: "",
  firstName: "",
  lastName: "",
  countryCode: "",
  phoneNumber: "",
  address: "",
};
const fieldInitialValues = {
  fieldName: "",
  acres: "",
  LLD: [],
  notes: "",
  cropId: "",
  SubFields: [],
  RemoveSubFields: [],
};

const scoutingInitialValues = {
  scoutTimeType: "scoutTimeTaken",
  scoutTime: "",
  scoutTimeManual: "",
  cropStage: "",
  cropStageFiles: [],
  removeCropStageFiles: [],
  observation: [
    {
      observation: "",
      observationFiles: [],
      removeObservationFiles: [],
    },
  ],
  recommendation: [
    {
      recommendation: "",
      recommendationFiles: [],
      removeRecommendationFiles: [],
    },
  ],
  mixSheetFile: "",
  removeMixSheetFile: [],
};

const cropPlanInitialValues = {
  data: [],
};
const addProductInitialValues = {
  productId: "",
  productName: "",
  rate: "",
  rateUnit:"",
  containerSize: "",
  containerUnit: "Ltr",
  containerType: "",
  notes: "",
};

// -----
const addCropPlanInitialValues = {
  growingSeason: "",
  description: "",
  planStatus: "Template",
};
const addCropInitialValues = {
  fieldId: [],
  cropName: "",
  fieldData: [],
  subFieldIds: [],
  cropId: "",
  variety: "",
  acres: "Values",
  acresValue: "",
  description: "",
};

const cropInitialValues = {
  cropId: "",
  cropName: "",
};
const yearInitialValues = {
  seasonId: "",
  year: "",
};

export {
  LoginInitialValues,
  growerInitialValues,
  forgotPasswordInitialValues,
  resetPasswordInitialValues,
  changePasswordInitialValues,
  profileInitialValues,
  fieldInitialValues,
  scoutingInitialValues,
  cropPlanInitialValues,
  addProductInitialValues,
  addCropPlanInitialValues,
  addCropInitialValues,
  cropInitialValues,
  yearInitialValues,
};
